import {createSelector, first} from 'helpers';
import {RootState} from 'store/root-state.type';

const WhatsNew: string = require('!raw-loader!components/settings/whats-new').default; // eslint-disable-line
const versions = [...WhatsNew.matchAll(/version="([0-9.]+)/g)].map(([,value]) => parseFloat(value));

const getUI = createSelector(
  (state: RootState) => state.settings,
  (settings) => ({
    webVersion: settings.webVersion,
    fullscreen: Boolean(settings.fullscreen),
    primaryNavigationCollapsed: Boolean(settings.primaryNavigationCollapsed),
    printTarget: settings.printTarget || 'main',
    theme: settings.theme
  })
);

const getLatestVersion = createSelector(() => {
  return first(versions);
});

const getNewItems = createSelector(
  (state: RootState) => state.settings.webVersion,
  (currentVersion) => versions.filter(version => version > parseFloat(currentVersion))
);

export const ui = createSelector(
  [getUI, getLatestVersion, getNewItems],
  (ui, latestVersion, newItems) => ({
    ...ui,
    latestVersion,
    updatesCount: newItems.length
  })
);
